import React from 'react'
import { Field, ErrorMessage } from 'formik'
import FieldWrapper from '../../FieldWrapper'
import MultiselectCheckboxAttributes from '../MultiselectCheckboxAttributes'
import MovieInformation from '../../../general/MovieInformation'
import WrapperAccordion from '../../../general/WrapperAccordion'
import config from '../../../../attribute-position-config.json'
import RadioButtonGroup from '../RadioButtonGroup'
import RadioButton from '../SingleSelectRadiobutton'
import DatePickerContainer from '../DatepickerContainer'
import Translation from '../../../Translation/cont/Translation'
import SourceField from '../SourceField'

const InformationAccordion = ({values, activeTabClass, setActiveTab, title, setFieldValue, classes, metaData, hasCountdownMovie, onChange, onReset}) => (
    <WrapperAccordion
        title={title}
        className={classes}
        selectionActiveClass={activeTabClass}
        collapseActiveSelection={setActiveTab}
        gapless={true}
    >
        <fieldset>
            <div className="form-content">
                <div className="left-sections">
                    <FieldWrapper label={<Translation id="movie_edit_movie_title" />} id="movie-title" classes="field-text">
                        <p id="movie-title" className="text-regular input-text-box">{values.movie.title}</p>
                    </FieldWrapper>

                    <FieldWrapper label={<Translation id="movie_edit_movie_title_display"/>} id="movie-title-display" classes="field-textarea field-textarea-text">
                        <Field component="textarea" name="movie.titleDisplay" cols="50" rows="1" wrap="hard" id="movie-title-display" className="text-regular input-text-box" />
                        <ErrorMessage name="movie.titleDisplay" component="div" id="movie-title-display"/> 
                    </FieldWrapper>
                    
                    <FieldWrapper label={<Translation id="movie_edit_movie_additional_text"/>} info={<Translation id="movie_edit_movie_additional_text_info"/>} id="movie-subtitle" classes="field-textarea field-textarea-text">
                        <Field component="textarea" name="movie.subTitle" cols="50" wrap="hard" rows="1" id="movie-subtitle" className="text-regular input-text-box" maxLength="70"/>
                        <ErrorMessage name="movie.subTitle" component="div" id="movie-subtitle"/> 
                    </FieldWrapper>
                    
                    <FieldWrapper label={<Translation id="movie_edit_movie_short_description" />} info={<Translation id="movie_edit_movie_short_description_info"/>} id="movie-description-short" classes="field-textarea field-textarea-text">
                        <Field name="movie.descriptionShort" component="textarea" cols="50" wrap="hard" maxLength="220" id="movie-description-short" className="text-small-light input-text-box" />
                        <ErrorMessage name="movie.descriptionShort" component="div" />
                    </FieldWrapper>

                    <FieldWrapper label={<Translation id="movie_edit_movie_description"/>} id="movie-description" classes="field-textarea field-textarea-text">
                        <Field name="movie.description" component="textarea" cols="50" wrap="hard" id="movie-description" className="text-small-light input-text-box" onChange = {onChange('description')} />
                        {metaData && <SourceField metaKey="description" metaValue={metaData.description} onReset={onReset}/>}
                        <ErrorMessage name="movie.description" component="div" />
                    </FieldWrapper>
                    
                    {_.has(values.movie, 'posterAttribute') && <FieldWrapper label={<Translation id="movie_edit_movie_poster_attribute"/>} info={<Translation id="movie_edit_movie_poster_attribute_info"/>} id="movie-posterattribute" classes="field-text">
                        <Field name="movie.posterAttribute.name" type="text" maxLength="20" id="movie-posterattribute" className="text-small-light input-text-box" />
                        <ErrorMessage name="movie.posterAttribute.name" component="div" />
                    </FieldWrapper>}
                    {_.has(values.movie, 'posterAttribute') && <RadioButtonGroup
                        label={<Translation id="movie_edit_movie_position"/>}
                        className="select-new-section-type attribute-position"
                    >
                        {config.positions.map(position => {
                            const {transId, id} = position
                            return (
                                <Field
                                    key={id}
                                    component={RadioButton}
                                    name="movie.posterAttribute.position"
                                    id={id}
                                    label={<Translation id={transId}/>}
                                    setFieldValue={setFieldValue}
                                />
                            )
                        })}
                    </RadioButtonGroup>}
                </div>

                <div className="right-sections">
                    <fieldset className="field-category field-genres">
                        <legend className="text-small-light"><Translation id="movie_edit_movie_genres"/></legend>

                        <div className="grid-container">
                            {Object.keys(values.attributes.global.genres).map(attrId => {
                                return (
                                    <div key={'field' + attrId} className="field-checkbox">
                                        <Field 
                                            key={attrId} 
                                            type="genres"
                                            attrid={attrId}
                                            movieid={values.movie.id}
                                            name={"movie.genres"} 
                                            component={MultiselectCheckboxAttributes} 
                                            value={values.attributes.global.genres[attrId]} 
                                            onClick={onChange('genres')}
                                        />
                                    </div>
                                )
                            })}
                        </div>
                    </fieldset>

                    <FieldWrapper label={<Translation id="movie_edit_movie_trailer"/>} id="movie-trailer" info={<Translation id="movie_edit_movie_trailer_info"/>} classes="field-text">
                        <Field type="url" name="movie.trailerURL" className="text-regular input-text-box" onChange = {onChange('trailerURL')} />
                        {metaData && <SourceField metaKey="trailerURL" metaValue={metaData.trailerURL} onReset={onReset}/>}
                        <ErrorMessage name="movie.trailerURL" component="div" id="movie-trailer"/> 
                    </FieldWrapper>

                    {hasCountdownMovie && <div className='field-text'>
                        <label>
                            <p className='gap-10'><Translation id="movie_edit_movie_countdown">Countdown anzeigen</Translation></p>
                        
                            <Field type="checkbox" checked={values.movie.showCountdown} id="active-title-top-text" className="checkbox tgl tgl-flat" onChange={() => {
                                setFieldValue('movie.showCountdown', !values.movie.showCountdown)
                            }}/>
                            <span className="tgl-btn text-regular"><span className='screen-reader-text'><Translation id="print_flyer_activate_customization">Aktiv</Translation></span></span>
                        </label>
                    </div>}

                    <MovieInformation 
                        movieData={values.movie}
                        keysToDisplay={[
                            "fsk",
                            "length",
                            "directors",
                            "origTitle",
                            "productionCountry",
                            "productionYear",
                            "actors",
                            "url",
                            "id"
                        ]}
                    />

                    <div className="datepicker-container">
                        <div className="datepicker-wrapper">
                            {values.movie.displayDates && <FieldWrapper label={<Translation id="movie_edit_movie_display_start_date"/>} description={<Translation id="movie_edit_movie_display_start_date_info"/>} id="movie-startdate" classes="datepicker-inner-wrapper">
                                <DatePickerContainer value={values.movie.displayDates.start} isStartDate={true} resetValue={'movie.displayDates.end'} end={values.movie.displayDates.end} name="movie.displayDates.start" onChange={setFieldValue} type="text" id="movie-startdate" className="text-small-light input-text-box" />
                                <ErrorMessage name="movie.displayDates.start" component="div" />
                            </FieldWrapper>}
                        </div>
                        <div className="datepicker-wrapper">
                            {values.movie.displayDates && <FieldWrapper label={<Translation id="movie_edit_movie_display_end_date"/>} description={<Translation id="movie_edit_movie_display_end_date_info"/>} id="movie-enddate" classes="datepicker-inner-wrapper">
                                <DatePickerContainer value={values.movie.displayDates.end} start={values.movie.displayDates.start} name="movie.displayDates.end" onChange={setFieldValue} type="text" id="movie-enddate" className="text-small-light input-text-box" />
                                <ErrorMessage name="movie.displayDates.end" component="div" />
                            </FieldWrapper>}
                        </div>
                    </div>
                </div>
            </div>
        </fieldset>
    </WrapperAccordion>
)


export default InformationAccordion